export const PHONE_HIT_AREA = [
  "max-md:[&_:is(button,a[href]):not(.absolute,.fixed,.sticky,.relative)]:relative",
  "max-md:[&_:is(button,a[href]):not(.absolute,.fixed,.sticky)]:after:absolute",
  "max-md:[&_:is(button,a[href]):not(.absolute,.fixed,.sticky)]:after:left-1/2",
  "max-md:[&_:is(button,a[href]):not(.absolute,.fixed,.sticky)]:after:top-1/2",
  "max-md:[&_:is(button,a[href]):not(.absolute,.fixed,.sticky)]:after:h-[max(100%,2.75rem)]",
  "max-md:[&_:is(button,a[href]):not(.absolute,.fixed,.sticky)]:after:w-[max(100%,2.75rem)]",
  "max-md:[&_:is(button,a[href]):not(.absolute,.fixed,.sticky)]:after:-translate-1/2",
  "max-md:[&_:is(button,a[href]):not(.absolute,.fixed,.sticky)]:after:content-['']",
];
